import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatTableCrudEditComponent } from "../../../shared/components/mat-table-crud/mat-table-crud-edit.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { LoggerService } from "../../../shared/services/logger.service";
import { ProductCategory } from "../administration.models";
import { AdministrationService } from '../administration.service';
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";

import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";


@Component({
    templateUrl: './product-category-edit.component.html',
    selector: 'product-category-edit-form',
    styleUrls: ['../../../shared/components/mat-table-crud/mat-table-crud.component.scss', './product-categories.component.scss'],
    providers: [MatTableCrudService],
    standalone: true,
    imports: [CdkDrag, FormsModule, ReactiveFormsModule, CdkDragHandle, MatDialogTitle, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDialogActions, MatButtonModule]
})
export class ProductCategoryEditComponent extends MatTableCrudEditComponent<ProductCategoryEditComponent, ProductCategory>
{
    constructor(public fb: UntypedFormBuilder, public dialogRef: MatDialogRef<ProductCategoryEditComponent>, @Inject(MAT_DIALOG_DATA) public data: ProductCategory, public administrationService: AdministrationService, public authorisationService: AuthorisationService, public loggerService: LoggerService)
    {
        super(dialogRef, data);

        this.form = this.fb.group({
            Id: [this.data.Id],
            ProductCategoryName: [this.data.ProductCategoryName, Validators.required],
            Disabled: [this.data.Disabled],
            SortOrder: [this.data.SortOrder, Validators.compose([Validators.required, Validators.pattern('^\\d+$')])]
        });

    }

    ngOnInit()
    {
        super.ngOnInit();

    }

    onSave(): void
    {
      const productCategory: any = this.form.value;

        if (productCategory)
        {
            if (this.isNew)
            {
                productCategory.Id = 0;

                if (productCategory.Disabled == null)
                {
                    productCategory.Disabled = false;
                }
            }

            productCategory[this.changedByField] = this.authorisationService.currentuser.Id;

            super.onSave(productCategory);
        }
    }

    get dialogHeaderText(): string
    {
        let headerText = "Edit Client Category";

        if (this.isNew)
        {
            headerText = "New Client Category";
        }
        else
        {
            if (this.showEditItemNameInHeaderText)
            {
                headerText = `${headerText} - ${this.data.ProductCategoryName}`;
            }
        }

        return headerText;
    }




    ngOnDestroy()
    {
        super.ngOnDestroy();

    }



}
